module.exports = __webpack_public_path__ + "img/jyb-office.0aaf6ad8.png";